// Utility to clear corrupted filter data from session storage
import logger from '../lib/logger';

export function clearBadFilterData() {
  const storageKey = 'filter-storage';

  try {
    const data = sessionStorage.getItem(storageKey);
    if (data && (data === '[object Object]' || data.includes('"[object Object]"'))) {
      logger.log('🔍 Found corrupted filter data, clearing...');
      sessionStorage.removeItem(storageKey);
      logger.log('✅ Corrupted filter data cleared');
      return true;
    }
    logger.log('✅ No corrupted filter data found');
    return false;
  } catch (error) {
    console.error('❌ Error clearing filter data:', error);
    return false;
  }
}

// Auto-run on import to clean up any existing bad data
if (typeof window !== 'undefined') {
  clearBadFilterData();
}
